// frontend-react/src/components/Layout/AdminSidebar.js - NUEVO ARCHIVO
import React from "react";
import {
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
  Typography,
  Box,
} from "@mui/material";
import {
  Dashboard,
  AutoAwesome,
  Schedule,
  Category,
  Analytics,
  People,
  Settings,
  Article,
  Image,
  AdsClick,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { Event, Home } from "@mui/icons-material";

const AdminSidebar = ({ open, onClose, width = 280, variant = "permanent" }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { text: "Dashboard", icon: <Dashboard />, path: "/admin", exact: true },
    { text: "Generación IA", icon: <AutoAwesome />, path: "/admin/ia" },
    {
      text: "Auto-Generación",
      icon: <Schedule />,
      path: "/admin/auto-generation",
    },
    { text: "Programación", icon: <Event />, path: "/admin/scheduling" },
    { text: "Categorías", icon: <Category />, path: "/admin/categories" },
    { text: "Borradores IA", icon: <Article />, path: "/admin/drafts" },
    { text: "Analytics", icon: <Analytics />, path: "/admin/analytics" },
    { text: "Usuarios", icon: <People />, path: "/admin/users" },
    { text: "Todos los Posts", icon: <Article />, path: "/admin/all-posts" },
  ];

  const handleMenuItemClick = (path) => {
    navigate(path);
    onClose?.();
  };

  const isActive = (item) => {
    if (item.exact) return location.pathname === item.path;
    return location.pathname.startsWith(item.path);
  };

  return (
    <Drawer
      variant={variant}
      open={open}
      onClose={onClose}
      sx={{
        width: variant === "permanent" ? (open ? width : 0) : width,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
          width: width,
          boxSizing: "border-box",
          transition: "transform 0.3s ease",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
          ...(variant === "permanent" && !open && {
            width: 0,
            border: "none",
          }),
        },
      }}
      ModalProps={{
        keepMounted: true, // Better open performance on mobile.
      }}
    >
      <Box sx={{ overflow: "auto", flexGrow: 1 }}>
        {/* Header del Sidebar */}
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h6" color="primary" fontWeight="bold">
            Panel Admin
          </Typography>
        </Box>

        <Divider />

        {/* Menú de Navegación */}
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.text} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                onClick={() => handleMenuItemClick(item.path)}
                selected={isActive(item)}
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                  "&.Mui-selected": {
                    backgroundColor: "primary.main",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "primary.dark",
                    },
                    "& .MuiListItemIcon-root": {
                      color: "white",
                    },
                  },
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: isActive(item) ? "white" : "inherit",
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={item.text}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>

      <Divider />

      {/* Botón Ir al Home */}
      <Box sx={{ p: 2 }}>
        <ListItemButton
          onClick={() => navigate("/")}
          sx={{
            borderRadius: 2,
            justifyContent: open ? "initial" : "center",
            px: 2.5,
            border: "1px solid",
            borderColor: "divider",
            "&:hover": {
              bgcolor: "action.hover",
            },
          }}
        >
          <ListItemIcon
            sx={{
              minWidth: 0,
              mr: open ? 3 : "auto",
              justifyContent: "center",
            }}
          >
            <Home />
          </ListItemIcon>
          <ListItemText
            primary="Ir al Home"
            sx={{ opacity: open ? 1 : 0 }}
          />
        </ListItemButton>
      </Box>

      <Divider />

      {/* Información rápida */}
      <Box sx={{ p: 2, opacity: open ? 1 : 0 }}>
        <Typography variant="body2" color="text.secondary" align="center">
          Vortix.Digital v1.0
        </Typography>
      </Box>
    </Drawer>
  );
};

export default AdminSidebar;
